<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn-primary" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn-primary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="w-1/2">
      <mat-label>選項</mat-label>
      <app-jkedit #title [visible]="true" [label]="'標題'" [required]="false" [(value)]="filterOpt.Title" [width]="'60'">
      </app-jkedit>
      <app-jkedit #ps [visible]="true" [label]="'備註'" [required]="false" [(value)]="filterOpt.PS" [width]="'60'">
      </app-jkedit>
      <app-jkcombobox #orderby label="排序方式" [(value)]="filterOpt.orderBy" [items]="orderList">
      </app-jkcombobox>
    </div>

  </mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event)" (rowClicked)="querySelect($event)">
    </app-jkgridwin>
    <label>{{logMessage}}</label>
  </mat-tab>
  <mat-tab #myDefineQuery label="自定查詢條件">
    <button class="btn-primary" (click)="goDefineQuery()">
      <mat-icon fontIcon="search"></mat-icon>自訂查詢
    </button>
    <app-jkcombobox #defineOrder label="排序方式" [(value)]="defineWin.order" [items]="defineOrderList">
    </app-jkcombobox>
    <app-jkedit #defineWinWhere [visible]="true" [label]="'固定查詢條件'" [required]="false" [(value)]="userWhere"
      [width]="'500'">
    </app-jkedit>
    <app-define-where #defineWhere [whereList]="WhereList"
      (comReady)="doComReady($event, 'defineWhere')"></app-define-where>
  </mat-tab>
  <mat-tab #myDefineQuery label="自定查詢結果">
    <app-jkgridwin #defineGridwin (afterGridReady)="afterGridReadyDefine($event)">
    </app-jkgridwin>
  </mat-tab>
  <mat-tab #myDebug label="除錯(ADMIN才有權限)">
    @if((uid === 'ADMIN') || (uid === 'JACK')){
    <app-jktextarea height="600px" label="除錯訊息" #debugMessage [value]="debugText" [required]="true"
      placeholder="where ..." [readonly]="isBrowse" class="w-full font-mono text-sm">
    </app-jktextarea>
    }@else{
    <label>你沒有權限</label>
    }
  </mat-tab>
</mat-tab-group>